import { breakpointUp } from '@slal/ui/helpers';
import { P } from '@slal/ui/typography';
import { rgba } from 'polished';
import ReactSlider from 'react-slider';
import styled from 'styled-components';
import { CardButton } from '../CardButton';

export const Wrapper = styled.div`
    color: ${({ theme }) => theme.colors.primaryText};
`;

export const ImagePreviewWrapper = styled.div`
    display: flex;
    flex-direction: column;
    ${breakpointUp.lg`
        flex-direction: row;
        `}
`;

export const FileUpload = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: ${({ theme }) => theme.colors.neutral__light__10};
    border: 1px solid ${({ theme }) => theme.colors.neutral__light__30};
    border-radius: 5px;
    padding: 30px 10px;
    max-width: 370px;
`;

export const Separator = styled(P)`
    font-size: 12px;
    line-height: 17px;
    text-align: center;

    &:before,
    &:after {
        position: relative;
        content: ' ';
        display: inline-block;
        top: -4px;
        width: 80px;
        margin: 0 10px;
        border-bottom: 1px solid ${({ theme }) => theme.colors.neutral__light__30};
    }
`;

export const UploadButton = styled(CardButton)`
    margin-top: ${({ theme }) => theme.space[5]};
    background-color: ${({ theme }) => theme.colors.neutral__light__20};
`;

export const UploadMessage = styled.p`
    font-size: 12px;
    line-height: 17px;
    max-width: 200px;
    text-align: center;
`;

export const ImagePreview = styled.div`
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: ${({ theme }) => theme.colors.neutral__light__10};
    border: 1px solid ${({ theme }) => theme.colors.neutral__light__30};
    border-radius: 5px;
    min-height: 160px;
    padding: 20px 0;
    margin-bottom: 10px;
    max-width: 370px;
    min-height: 250px;
`;

export const ImageScaling = styled.div`
    margin: 14px 0px;
    max-width: 370px;
    ${breakpointUp.lg`
        margin-left: 30px;
        margin-top: 50px;
        `}
`;

export const DeleteButton = styled.button`
    position: absolute;
    top: 8px;
    right: 8px;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 25px;
    height: 25px;
    border-radius: 50%;
    border: none;
    background-color: ${({ theme }) => rgba(theme.colors.blue__secondary__70, 0.15)};
    > svg {
        height: 20px;
        color: ${({ theme }) => theme.colors.blue__secondary__70};
    }
`;

export const Image = styled.img`
    height: auto;
    width: 50%;
    background-color: ${({ theme }) => theme.colors.neutral__light__90};
`;

export const Slider = styled(ReactSlider as unknown as React.ComponentType<React.ComponentProps<typeof ReactSlider>>)`
    .slider-thumb {
        background-color: white;
        width: 20px;
        height: 20px;
        border-radius: 50%;
        border: 2px solid ${({ theme }) => theme.colors.aqua__70};
    }

    .slider-track {
        height: 4px;
        margin-top: 8px;
        border-radius: 2px;
        background-color: ${({ theme }) => theme.colors.blue__primary__100};
    }

    .slider-track-0 {
        background-color: ${({ theme }) => theme.colors.aqua__70};
    }

    .slider-track-1 {
        background-color: ${({ theme }) => theme.colors.neutral__light__30};
    }
`;

export const ScalingHelpText = styled(P)`
    margin: 8px 0;
    font-size: ${({ theme }) => theme.fontSizes[3]};
    color: ${({ theme }) => theme.colors.neutral__light__70};
`;

export const SliderLabel = styled.p`
    font-size: ${({ theme }) => theme.fontSizes[4]};
    margin: 0;
`;
